import React from 'react';
import Link from "next/link";
import { ParallaxProvider, ParallaxBanner, ParallaxBannerLayer } from 'react-scroll-parallax';
import { useTranslations } from '../../locales/useTranslations';
import { BiSolidEnvelope } from "react-icons/bi";

const ParallaxMainBanner = () => {
  const { t } = useTranslations();

  return (
    <ParallaxProvider>
      <ParallaxBanner >
        <div className="landingparallaxbanner">
          <ParallaxBannerLayer className='ParallaxBannerLayer' image="/images/parallax/Kiel_09_Back_Blue-version.webp" speed={10} />
          <ParallaxBannerLayer className='ParallaxBannerLayer' image="/images/parallax/Kiel_08_Tower.webp" speed={-10} />
          <ParallaxBannerLayer className='ParallaxBannerLayer' image="/images/parallax/Kiel_07_Cityline.webp" speed={-5} />
          <ParallaxBannerLayer className='ParallaxBannerLayer' image="/images/parallax/Kiel_06_Cityhall.webp" speed={0} />
          <ParallaxBannerLayer className='ParallaxBannerLayer' image="/images/parallax/Kiel_05_Parliament.webp" speed={0} />
          <ParallaxBannerLayer className='ParallaxBannerLayer' image="/images/parallax/Kiel_04_Hoern_bay.webp" speed={0} />
          <ParallaxBannerLayer className='ParallaxBannerLayer' image="/images/parallax/Kiel_03_Crane-2.webp" speed={0} />
          <ParallaxBannerLayer className='ParallaxBannerLayer' image="/images/parallax/Kiel_02_Crane.webp" speed={0} />
          <ParallaxBannerLayer className='ParallaxBannerLayer' image="/images/parallax/Kiel_01_Boats.webp" speed={10} />
          <div className="landingpage-banner">
            <div className="container">
              <div className="landingpage-banner-content">
                <h1
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="1200"
                >
                  {t('homepage_banner_title')}
                  <br />
                  <span>{t('homepage_banner_subtitle')}</span>
                  <br />
                  {t('homepage_banner_title2')}
                </h1>

                <div
                  data-aos="fade-up"
                  data-aos-delay="300"
                  data-aos-duration="1200"
                >
                  <Link href="/kontakt" className="default-btn">
                    <BiSolidEnvelope />{t('homepage_banner_button')}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ParallaxBanner>
    </ParallaxProvider >
  );
};

export default ParallaxMainBanner;